import PropTypes, { shape, string } from 'prop-types'

import childrenSchema from './children'

export default shape({
  children: PropTypes.arrayOf(childrenSchema).isRequired,
  droppableId: string.isRequired,
})
